import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './full-image-video-updated.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/generic-image/index.js';

function toAriaList(ariaLabel) {
    return ariaLabel ? { 'aria-label': ariaLabel } : {};
}
function buildAriaList(cta) {
    const list = toAriaList(cta === null || cta === void 0 ? void 0 : cta.ariaLabel);
    if (cta === null || cta === void 0 ? void 0 : cta.onClick) {
        list['aria-haspopup'] = 'dialog';
    }
    return list;
}
const jsonConverter = {
    fromAttribute: (v) => {
        try {
            return v ? JSON.parse(v) : undefined;
        }
        catch (_a) {
            return undefined;
        }
    },
    toAttribute: () => null,
};
class FullImageVideoUpdated extends s {
    constructor() {
        super(...arguments);
        this.imageUrl = '';
        this.imageAltText = '';
        this.styleVariations = 'gradient';
        this.rtl = false;
        this.heading = '';
        this.body = '';
        this.imageSrc = '';
        this.imageAlt = '';
        this.followMobileOnLaptop = true;
        this.isPriority = false;
        this.aspectRatio = '16:9';
        this.isLaptop = false;
        this.updateAspectRatio = () => {
            const w = window.innerWidth;
            this.aspectRatio = w >= 1024 ? '21:9' : '16:9';
            this.isLaptop = w >= 1024 && w < 1440;
        };
        this.updateButtonMaxWidth = () => {
            if (window.innerWidth < FullImageVideoUpdated.LAPTOP_BREAKPOINT)
                return;
            const ctasContainer = this.renderRoot.querySelector('.fiv__ctas');
            if (!ctasContainer)
                return;
            const buttons = Array.from(ctasContainer.querySelectorAll('generic-button-updated'));
            if (buttons.length === 0)
                return;
            this.measureAndDistribute(buttons, ctasContainer);
        };
    }
    get dirAttr() {
        return this.rtl || isRTL() ? 'rtl' : 'ltr';
    }
    resolveImgSrc() {
        return this.imageUrl || this.imageSrc || '';
    }
    resolveImgAlt() {
        return this.imageAltText || this.imageAlt || '';
    }
    get variationClass() {
        const v = (this.styleVariations || 'gradient').toLowerCase();
        return ['gradient', 'purple', 'burgundy'].includes(v)
            ? `fiv--${v}`
            : 'fiv--gradient';
    }
    measureNaturalButtonWidth(btn) {
        var _a, _b, _c;
        const btnEl = (_a = btn.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.btn');
        const label = btnEl === null || btnEl === void 0 ? void 0 : btnEl.querySelector('.btn-label');
        const text = (_c = (_b = label === null || label === void 0 ? void 0 : label.textContent) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : '';
        const computedMinWidth = parseInt(window.getComputedStyle(btn).minWidth, 10) ||
            FullImageVideoUpdated.BUTTON_MIN_WIDTH;
        if (!text)
            return computedMinWidth;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return computedMinWidth;
        ctx.font = btnEl
            ? window.getComputedStyle(btnEl).font
            : `16px "Noto Sans", sans-serif`;
        const textWidth = Math.ceil(ctx.measureText(text).width);
        return Math.max(textWidth + FullImageVideoUpdated.BUTTON_HORIZONTAL_PADDING, computedMinWidth);
    }
    calculateDistributedWidths(naturalWidths, availableWidth) {
        const equalShare = Math.floor(availableWidth / naturalWidths.length);
        const maxWidths = new Array(naturalWidths.length).fill(0);
        const needsMoreSpace = [];
        let remaining = availableWidth;
        naturalWidths.forEach((naturalWidth, i) => {
            if (naturalWidth <= equalShare) {
                maxWidths[i] = Math.ceil(naturalWidth);
                remaining -= maxWidths[i];
            }
            else {
                needsMoreSpace.push(i);
            }
        });
        if (needsMoreSpace.length > 0) {
            const shareForRemaining = Math.floor(remaining / needsMoreSpace.length);
            needsMoreSpace.forEach(i => { maxWidths[i] = shareForRemaining; });
        }
        return maxWidths;
    }
    applyButtonWidths(buttons, maxWidths) {
        buttons.forEach((btn, i) => {
            btn.style.setProperty(FullImageVideoUpdated.BUTTON_MAX_WIDTH_VAR, `${maxWidths[i]}px`);
        });
    }
    measureAndDistribute(buttons, ctasContainer) {
        const { BUTTON_GAP, BUTTON_MAX_WIDTH_VAR, BUTTON_OVERFLOW_TOLERANCE } = FullImageVideoUpdated;
        const availableWidth = ctasContainer.clientWidth - BUTTON_GAP * (buttons.length - 1);
        const naturalWidths = buttons.map(btn => this.measureNaturalButtonWidth(btn));
        const totalNaturalWidth = naturalWidths.reduce((sum, w) => sum + w, 0);
        if (totalNaturalWidth <= availableWidth) {
            buttons.forEach(btn => btn.style.removeProperty(BUTTON_MAX_WIDTH_VAR));
            return;
        }
        const effectiveWidth = availableWidth + BUTTON_OVERFLOW_TOLERANCE;
        this.applyButtonWidths(buttons, this.calculateDistributedWidths(naturalWidths, effectiveWidth));
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateAspectRatio();
        window.addEventListener('resize', this.updateAspectRatio, {
            passive: true,
        });
        window.addEventListener('resize', this.updateButtonMaxWidth, {
            passive: true,
        });
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.updateAspectRatio);
        window.removeEventListener('resize', this.updateButtonMaxWidth);
        super.disconnectedCallback();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        this.initButtonMaxWidth();
    }
    initButtonMaxWidth() {
        if (window.innerWidth < FullImageVideoUpdated.LAPTOP_BREAKPOINT)
            return;
        const ctasContainer = this.renderRoot.querySelector('.fiv__ctas');
        if (!ctasContainer)
            return;
        const buttons = Array.from(ctasContainer.querySelectorAll('generic-button-updated'));
        if (buttons.length === 0)
            return;
        customElements.whenDefined('generic-button-updated').then(() => Promise.all(buttons.map(btn => { var _a; return (_a = btn.updateComplete) !== null && _a !== void 0 ? _a : Promise.resolve(); }))
            .then(() => this.measureAndDistribute(buttons, ctasContainer)));
    }
    renderCta(kind, cta) {
        var _a, _b, _c;
        if (!(cta === null || cta === void 0 ? void 0 : cta.title))
            return null;
        const classes = `fiv__cta fiv__cta--${kind}`;
        return $ `<generic-button-updated class="${classes}" .type="${kind}" .styleType="${'dark'}" .color="${'purple'}" .label="${cta.title}" .href="${(_a = cta.url) !== null && _a !== void 0 ? _a : ''}" .target="${(_b = cta.target) !== null && _b !== void 0 ? _b : ''}" .isNoFollow="${!!cta.isNoFollow}" .rtl="${this.rtl}" onClick="${(_c = cta.onClick) !== null && _c !== void 0 ? _c : ''}" .ariaList="${buildAriaList(cta)}"></generic-button-updated>`;
    }
    renderHeading(h) {
        const truncatedHeading = this.truncateText(h, 70);
        return truncatedHeading
            ? $ `<h1 class="fiv__title" id="full-video-heading">${o(truncatedHeading)}</h1>`
            : null;
    }
    truncateText(text, maxLength = 270) {
        if (!text || text.length <= maxLength)
            return text;
        return `${text.substring(0, maxLength).trim()}...`;
    }
    renderBodyText(b) {
        const truncatedText = this.truncateText(b);
        return truncatedText
            ? $ `<p class="fiv__body" id="full-video-body">${o(truncatedText)}</p>`
            : null;
    }
    renderImage(src, alt) {
        return src
            ? $ `<generic-image class="fiv__img" src="${src}" alt="${alt || ''}" aspect-ratio="${this.aspectRatio}" loading="${this.isPriority ? 'eager' : 'lazy'}" fetchpriority="${this.isPriority ? 'high' : 'auto'}"></generic-image>`
            : null;
    }
    render() {
        const imgSrc = this.resolveImgSrc();
        const imgAlt = this.resolveImgAlt();
        const ariaDescribedBy = this.body ? 'full-video-body' : undefined;
        const layoutClass = this.followMobileOnLaptop && this.isLaptop ? 'fiv--mobile-on-laptop' : '';
        const sectionClass = `fiv ${this.variationClass} ${layoutClass}`.trim();
        return $ `<section class="${sectionClass}" aria-labelledby="full-video-heading" aria-describedby="${ariaDescribedBy !== null && ariaDescribedBy !== void 0 ? ariaDescribedBy : w}" dir="${this.dirAttr}"><div class="fiv__content"><div class="fiv__content-inner">${this.renderHeading(this.heading)} ${this.renderBodyText(this.body)}<div class="fiv__ctas" role="group" aria-labelledby="full-video-heading">${this.renderCta('primary', this.primaryButton)} ${this.renderCta('secondary', this.secondaryButton)}</div></div></div><div class="fiv__media" aria-hidden="${imgAlt ? 'false' : 'true'}">${this.renderImage(imgSrc, imgAlt)}</div></section>`;
    }
}
FullImageVideoUpdated.styles = css_248z;
FullImageVideoUpdated.BUTTON_MAX_WIDTH_VAR = '--button-max-width';
FullImageVideoUpdated.BUTTON_GAP = 24;
FullImageVideoUpdated.BUTTON_MIN_WIDTH = 117;
FullImageVideoUpdated.BUTTON_HORIZONTAL_PADDING = 32;
FullImageVideoUpdated.BUTTON_OVERFLOW_TOLERANCE = 1;
FullImageVideoUpdated.LAPTOP_BREAKPOINT = 1024;
__decorate([
    e({ type: String })
], FullImageVideoUpdated.prototype, "imageUrl", void 0);
__decorate([
    e({ type: String })
], FullImageVideoUpdated.prototype, "imageAltText", void 0);
__decorate([
    e({ type: String })
], FullImageVideoUpdated.prototype, "styleVariations", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], FullImageVideoUpdated.prototype, "rtl", void 0);
__decorate([
    e({ attribute: 'primarybutton', converter: jsonConverter })
], FullImageVideoUpdated.prototype, "primaryButton", void 0);
__decorate([
    e({ attribute: 'secondarybutton', converter: jsonConverter })
], FullImageVideoUpdated.prototype, "secondaryButton", void 0);
__decorate([
    e({ type: String })
], FullImageVideoUpdated.prototype, "heading", void 0);
__decorate([
    e({ type: String })
], FullImageVideoUpdated.prototype, "body", void 0);
__decorate([
    e({ type: String })
], FullImageVideoUpdated.prototype, "imageSrc", void 0);
__decorate([
    e({ type: String })
], FullImageVideoUpdated.prototype, "imageAlt", void 0);
__decorate([
    e({ type: Boolean })
], FullImageVideoUpdated.prototype, "followMobileOnLaptop", void 0);
__decorate([
    e({ type: Boolean })
], FullImageVideoUpdated.prototype, "isPriority", void 0);
__decorate([
    t()
], FullImageVideoUpdated.prototype, "aspectRatio", void 0);
__decorate([
    t()
], FullImageVideoUpdated.prototype, "isLaptop", void 0);
customElements.define('full-image-video-updated', FullImageVideoUpdated);

export { FullImageVideoUpdated };
